import { createContext, useContext } from 'react';

export const FriendshipContext = createContext();
export const useFriendship = () => useContext(FriendshipContext);
